import {
  Box,
  Button,
  Link,
  Tooltip,
  Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import {
  getHelpTerm,
} from "../help/helpTerms";


function openHelpTarget(target) {
  if (!target) {
    return;
  }

  const url =
    new URL(
      "/help",
      window.location.origin,
    );

  url.searchParams.set(
    "target",
    target,
  );

  window.open(
    url.toString(),
    "_blank",
    "noopener,noreferrer",
  );
}


export function HelpTerm({
  termKey,
  children,
}) {
  const {
    t,
  } = useTranslation();

  const config =
    getHelpTerm(
      termKey,
    );

  if (!config) {
    return children;
  }

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <Box
          sx={{
            p: 1,
            maxWidth: 320,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 800,
            }}
          >
            {children}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              mt: 0.5,
            }}
          >
            {t(
              config.tooltipKey,
            )}
          </Typography>

          {config.target && (
            <Button
              size="small"
              variant="text"
              onClick={(event) => {
                event.stopPropagation();

                openHelpTarget(
                  config.target,
                );
              }}
              sx={{
                mt: 0.5,
                px: 0,
                minWidth: 0,
                textTransform:
                  "none",
              }}
            >
              {t(
                "help.terms.readMore",
              )}
            </Button>
          )}
        </Box>
      }
    >
      <Link
        component="span"
        underline="always"
        sx={{
          cursor: "help",
          color: "inherit",
          textDecorationStyle:
            "dotted",
          textDecorationThickness:
            "1px",
        }}
      >
        {children}
      </Link>
    </Tooltip>
  );
}
